<nz-modal
  nzWrapClassName="vertical-center-modal"
  nzClassName="charts-modal-container"
  [(nzVisible)]="modalVisible"
  nzTitle="Edit Line Items"
  (nzOnCancel)="handleModalCancel()"
  nzWidth="950px"
>
<ng-container *nzModalContent>
  <app-edit-charts-li
    [addColTableData]="addColTableData"
    [selectedPeriod]="selectedPeriod"
    [stdLineItems]="stdLineItems"
    [maxHeight]="'300px'"
    [tickers]="tickers"
    [max]="2"
    lineItemInputId="chartsLiModalLineItemInput"
    (onLiUpdate)="updateChartLI($event)"
  ></app-edit-charts-li>
</ng-container>
  <div *nzModalFooter class="edit-line-item-modal-footer">
    <button nz-button nzType="default" (click)="handleModalCancel()">
      <span>Cancel</span>
    </button>
    <button
      nz-button
      [title]="
      this.modalData.length > this.max ? 'Max number of tickers is 3' : ''
    "
      nzType="primary"
      (click)="updateLineitems()"
      [ngClass]="this.modalData.length > this.max ? 'disable-btn' : ''"
      [disabled]="this.modalData.length === 0"
    >
      <span>Update</span>
    </button>
  </div>
</nz-modal>
